const AutoHostBuildStatusConstants = {
  INPROGESS: 0,
  SUCCESS: 1,
  FAILED: 2,
}

export default AutoHostBuildStatusConstants
